import { debounce } from 'lodash-es'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { dialog } from 'src/components/Modal/DynamicModal'
import SocialShare, {
  SystemShareButton,
} from 'src/components/SocialShare/SocialShare'
import type { Manga } from 'src/services/apollo/generated/graphql'
import { MangaType } from 'src/services/apollo/generated/graphql'
import { getPublicUrl } from 'src/utils/media'
import { getUserDisplayName } from 'src/utils/user'

export function useDialogMangaShare() {
  const { t } = useTranslation()

  return useCallback(
    debounce((manga: Manga) => {
      const isAnimatedComic = manga.type === MangaType.AnimatedComic

      const shareButtonProps = {
        link: `${window.location.origin}/${
          isAnimatedComic ? 'animated-comic' : 'manga'
        }/${manga.id}`,
        image: getPublicUrl(manga.coverMedia),
        text: t(`manga:social-share-text`, {
          authorName: getUserDisplayName(manga.author),
        }),
      }

      dialog({
        children: (
          <div className="p-5 pb-6 flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-xl leading-none pb-1 font-sans">Share</div>
                {manga.author?.username && (
                  <div className="text-xs">
                    {isAnimatedComic ? 'Animated comic' : 'Manga'} by @
                    {manga.author?.username}
                  </div>
                )}
              </div>

              {!!navigator.share && <SystemShareButton {...shareButtonProps} />}
            </div>

            <SocialShare {...shareButtonProps} />
          </div>
        ),
        fullWidth: true,
        maxWidth: 'xs',
        classes: {
          paper: 'rounded-xl',
        },
      })
    }, 100),
    [t],
  )
}
